import GlobalsStoreModule from '@app/store/modules/GlobalsStoreModule';
import PresentationStoreModule from '@app/store/modules/PresentationStoreModule';
import MapTransform from '@app/transforms/MapTransform';
import ILocation from '@app/types/base/ILocation';
import IImage from '@app/types/data/base/IImage';
import IMapLabel from '@app/types/data/base/IMapLabel';
import IHomeSlideData from '@app/types/data/slides/IHomeSlideData';
import IChapterMaster from '@app/types/presentations/master/IChapterMaster';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import AbstractSlideTransform from './AbstractSlideTransform';

/**
 * Transform for 003-HomeSlideTransform
 */
export default class HomeSlideTransform extends AbstractSlideTransform {
	public viewComponent: string = 'HomeSlide';

	public async transform(slide: ISlideMaster): Promise<IHomeSlideData> {
		const globalsStore: GlobalsStoreModule = getStoreModule(GlobalsStoreModule);
		const presentationStore: PresentationStoreModule = getStoreModule(PresentationStoreModule);

		const chapters: IChapterMaster[] = Object.values(presentationStore.master.chaptersById).filter(
			(chapter: IChapterMaster): boolean => presentationStore.selectedChapterIds.includes(chapter.id)
		);

		const data: IHomeSlideData = {
			id: slide.id,
			label: slide.fields.label,
			thumbnail: this.extractThumbnail(slide.fields.headline, slide, 'image'),
			image: this.transformImageAsset(slide.fields.image?.fields.asset ?? this.getFallbackImage(), {
				width: 5000,
				height: 5000,
				crop: 'limit'
			}),
			map: MapTransform.getSvg(slide.fields.map) as string,
			mapLabels: globalsStore.locations
				.map((location: ILocation): IMapLabel | null => {
					const chapterForLocation = chapters.find(
						(chapter: IChapterMaster): boolean => chapter.svgId === location.svgId
					);

					if (!location.svgId) {
						return null;
					}

					let image: IImage | undefined;

					if (location.image) {
						image = {
							...this.transformImageAsset(location.image, {
								width: 300, // eslint-disable-line
								height: 300, // eslint-disable-line
								crop: 'fill' // eslint-disable-line
							}),
							aspectRatio: '1x1'
						};
					}

					return {
						id: chapterForLocation ? chapterForLocation.id : location.id,
						svgId: location.svgId,
						type: 'location',
						label: location.title,
						labelAddOn: location.addOn,
						isSelectable: !!chapterForLocation,
						image
					};
				})
				.filter((mapLabel: IMapLabel | null): boolean => !!mapLabel) as IMapLabel[]
		};

		return data;
	}
}
